import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import gitalogo from "../Images/logo_Main.png";
import IndianFlag from "../Images/flag-India.png";
import UKFlag from "../Images/flag-uk.png";
import arrowdown from "../assets/img/dropdown-whiteIcon.png";
import arrowdownblack from "../assets/img/dropdownblack.svg";
import i18n, { _get_i18Lang } from "../i18n";
import interneticon from "../Images/signal.png"

const NoInternet = () => {
  const { t } = useTranslation();
  const dropdownRef: any = useRef(null);

  const [hoveredLang, setHoveredLang] = useState<any>(null);
  const [showLang, setShowLang] = useState<boolean>(false);

  function toggleLang() {
    setShowLang((wasOpened) => !wasOpened);
  }

  function changeLocale(l: string) {
    i18n.changeLanguage(l);
    localStorage.setItem("lan", _get_i18Lang());
    localStorage.setItem("locale", l);
    if (localStorage.getItem("locale") === "en") {
      $(".select-lang").removeClass("langwidth");
    } else {
      $(".select-lang").addClass("langwidth");
    }
  }

  return (
    <div>
      <div className="gst-header" style={{ display: "flex", justifyContent: "space-evenly" }}>
        <img src={gitalogo} alt="gstlogo" />
        <div style={{ marginTop: "3%" }}>
          <div
            className="allCatSearch"
            style={{
              padding: "2px 10px 0 6px",
              borderRadius: "4px",
              width: "120px",
              border: "none",
              cursor: "pointer",
              marginLeft: "12px",
              display: "flex",
              justifyContent: "space-between",
              backgroundColor: "#FFA54F",
              color: "#FFFFFF",

            }}
            onClick={toggleLang}
          >
            {localStorage.getItem("locale") === "hi" ? (
              <>
                <img
                  src={IndianFlag}
                  alt=""
                  style={{ margin: "0 8px 0 2px", borderRadius: "5px" }}
                />{" "}
                हिन्दी
              </>
            ) : (
              <>
                <img
                  src={UKFlag}
                  alt=""
                  style={{ margin: "0 8px 0 2px", borderRadius: "5px" }}
                />{" "}
                English
              </>
            )}
            <img
              src={arrowdown}
              alt="arrowdown"
              style={{
                width: "25px",
                filter: "drop-shadow(0 0 2px white)",
              }}
            />
          </div>
          <div>
            {showLang && (
              <div
                ref={dropdownRef}
                className="dropdownstyle"
                style={{
                  position: "absolute",
                  zIndex: 1,
                  left: '68%',
                  top: '38%',

                }}
              >
                <div
                  className="activelang"
                  style={{
                    margin: "25px 0 0 0",
                    border: "1px solid gray",
                    textAlign: "center",
                    width: "110px",
                    backgroundColor:
                      hoveredLang === "हिन्दी" ? "#A13316" : "#FDEBCB", // lighter on hover
                    cursor: "pointer",
                    display: "flex",
                  }}
                  onClick={() => {
                    setShowLang(false);
                    changeLocale("hi");
                  }}
                  onMouseEnter={() => setHoveredLang("हिन्दी")}
                  onMouseLeave={() => setHoveredLang(null)}
                >
                  <img
                    src={IndianFlag}
                    style={{
                      width: "30%",
                      margin: "0 5px",
                      borderRadius: "5px",
                    }}
                    alt="india-flag"
                  />
                  <p
                    style={{
                      color:
                        hoveredLang === "हिन्दी" ? "#fff" : "#822F1A",
                    }}
                  >
                    हिन्दी
                  </p>
                </div>
                <div
                  className="activelang"
                  style={{
                    marginTop: "-4px",
                    border: "1px solid gray",
                    textAlign: "center",
                    backgroundColor:
                      hoveredLang === "English" ? "#A13316" : "#FDEBCB", // lighter on hover
                    cursor: "pointer",
                    width: "110px",
                    display: "flex",
                  }}
                  onClick={() => {
                    setShowLang(false);
                    changeLocale("en");
                  }}
                  onMouseEnter={() => setHoveredLang("English")}
                  onMouseLeave={() => setHoveredLang(null)}
                >
                  <img
                    src={UKFlag}
                    style={{
                      width: "30%",
                      margin: "0 5px",
                      borderRadius: "5px",
                    }}
                    alt="india-flag"
                  />
                  <p
                    style={{
                      color:
                        hoveredLang === "English" ? "#fff" : "#822F1A",
                    }}
                  >
                    English
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="text-center gst-homebg-image" style={{ padding: "7% 0" }}>
        <div style={{
          backgroundColor: "rgba(255, 255, 255, 0.75)",
          margin: "0 20%",
          borderRadius: "10px",
          padding: "22px 0px"
        }}>
          {/* <div style={{ display: "ruby" }}> */}
          <img src={interneticon} alt="interneticon" style={{ width: "7%", height: "15%" }} />
          <h1 className="text-4xl" style={{ padding: "25px 0", color: "#9e1111", fontWeight: "600" }}>No Internet Connection</h1>
          {/* </div>/ */}
          <p className="text-lg" style={{ fontSize: "30px", color: "#2f2f2f", margin: localStorage.getItem("lan") === "hindi" ? "4% 0" : "2% 0" }}>
            {t("no_internet_tr")}
          </p>
          <div style={{
            padding: "4% 0"
          }}>
            <h3 style={{ color: "#9e1111" }}>
              कर्मण्येवाधिकारस्ते मा फलेषु कदाचन। <br />
              मा कर्मफलहेतुर्भूर्मा ते सङ्गोऽस्त्वकर्मणि॥</h3>
          </div>
        </div>
      </div>

      <div
        style={{
          textAlign: "center",
          color: "#3f220d",
          fontSize: "13px",
          fontFamily: "Arial",
          padding: "25px 13px 5px 15px",
          backgroundColor: "#fee3a3",
          borderTop: "1px solid #fff2d3",
        }}
      >
        <p
          className="gst-copyright"
          style={{
            fontSize: "12px", /* Might look okay on some smaller screens */
          }}
        >
          © Copyright
          <span style={{ margin: "0 2px" }}> | </span>
          <span style={{ color: "#fe7921" }}>Gita Seva Trust</span>
          <span style={{ margin: "0 3px" }}> | </span>
          All Rights Reserved 2017 - {new Date().getFullYear()}
          <span
            style={{
              /* This will likely cause issues on smaller screens */
              paddingLeft: "10px",
              display: "block", /* Trying to force stacking, but not dynamic */
              marginTop: "5px",
            }}
          >
            Web Developed & Managed By:
            <a
              href="https://gitaseva.org/"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              Gita Seva Trust
            </a>
          </span>
        </p>
      </div>
    </div>
  );
};
export default NoInternet;